// 灵犀上报函数
import Vue from 'vue';
// 公共配置
const valLabBase = {};

class LxMethods {
  // id: cid
  pv(id: string, valLab: {}) {
    window.LXAnalytics('pageView', {
      custom: Object.assign(valLabBase, valLab)
    }, null, id);
  }
  // id: bid
  mv(id: string, valLab: {}) {
    window.LXAnalytics('moduleView', id, {
      ...valLabBase,
      ...valLab
    });
  }
  // id: bid
  mc(id: string, valLab: {}) {
    window.LXAnalytics('moduleClick', id, {
      ...valLabBase,
      ...valLab
    });
  }
}

Vue.prototype.$lx = new LxMethods();

